import _pt from 'prop-types';
import 'react';
import { jsx } from '@emotion/core';
import { observer } from 'mobx-react';
import { withStores } from "../contexts/StoresContext.js";
import useStores from "../hooks/useStores.js";
import { Fillable } from "../contexts/AnnotationContext.js";
import PdfDocument from "../components/PdfDocument.js";
import SignatureModal from "../components/SignatureModal.js";

var FillablePdf = function FillablePdf(_ref) {
  var pdfFileLink = _ref.pdfFileLink,
      annotationFields = _ref.annotationFields,
      _ref$viewOnly = _ref.viewOnly,
      viewOnly = _ref$viewOnly === void 0 ? false : _ref$viewOnly,
      template = _ref.template,
      index = _ref.index,
      onCreateSignature = _ref.onCreateSignature;

  var _useStores = useStores(),
      pdfStore = _useStores.pdfStore,
      signatureStore = _useStores.signatureStore;

  return jsx(Fillable, {
    viewOnly: viewOnly,
    signingDisabled: pdfStore.signingDisabled,
    modifyingFieldPropertiesEnabled: pdfStore.modifyingFieldPropertiesEnabled
  }, jsx(PdfDocument, {
    pdfFileLink: pdfFileLink,
    annotationFields: annotationFields,
    template: template,
    index: index
  }), jsx(SignatureModal, {
    isOpen: signatureStore.signatureModalOpen,
    onClose: function onClose() {
      var _document$getElementB;

      signatureStore.setSignatureModalOpen(false);
      (_document$getElementB = document.getElementById('page-annotation-layer')) === null || _document$getElementB === void 0 ? void 0 : _document$getElementB.focus({
        preventScroll: true
      });
    },
    onSubmit: function onSubmit(fullName, initials) {
      onCreateSignature === null || onCreateSignature === void 0 ? void 0 : onCreateSignature({
        fullName: fullName,
        initials: initials
      });
      signatureStore.signField(pdfStore.selectedField);
    }
  }));
};

FillablePdf.displayName = "FillablePdf";
FillablePdf.propTypes = {
  pdfFileLink: _pt.string.isRequired,
  annotationFields: _pt.array.isRequired,
  viewOnly: _pt.bool,
  index: _pt.number,
  onCreateSignature: _pt.func,
  children: _pt.node
};
var FillablePdf$1 = withStores(observer(FillablePdf));
export default FillablePdf$1;